import React, { FC } from 'react';
import { TableProps } from 'react-bootstrap';
import styles from './mdc-table.module.sass';


export const YoTable: FC<TableProps> = ({ className, children, ...props }) => {
    return <table {...props}
                  className={`${styles.materialTable} ${className ?? ''}`}>{children}</table>;
};
